import React from "react";

import AOS from "aos";
import "./../../node_modules/aos/dist/aos.css";

const MainTeam = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  AOS.init({
    duration: 1000,
  });
  return (
    <div className="grid grid-col-12 mt-20">
      <div
        data-aos="fade-up"
        className="uppercase lg:text-5xl md:text-3xl xl:text-6xl text-2xl py-5  pl-4 md:pl-0 md:col-start-2 md:col-span-10 col-span-12"
      >
        KNOWLEDGEABLE & COMMITED PEOPLE.
      </div>
      <div className=" text-lg   col-span-12 ">
        {/* -----------------denice------------------- */}
        <div className="p-10 ">
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>DENICE TUMAINI || Managing Partner</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="md:w-2/3 w-full md:pr-4"
              align="justify"
              data-aos="fade-right"
            >
              Denice Tumaini practices in Commercial and Civil Litigation,
              Judicial Review, Tax Disputes, Arbitration, Receivership,
              Intellectual Property, Sports and Entertainment, Insurance,
              banking and Mortgage Financing, corporate aspects as well as Real
              estate and Conveyance. He is a duly admitted and enrolled Advocate
              of the High Court of Tanzania and Court’s subordinate thereto
              serve for the Primary Courts. He possesses enormous field
              experience, knowledge and skills acquired under the mentorship of
              one of the litigation Moguls in Tanzania Mr. Beatus Malima;
              Recovery, merger and acquisition Expert Mr. Joseph Nuwamanya and
              Corporate aspects from the renown corporate and Tax Law expert
              Lemmy Bartholomew of Mawalla Advocates. Under the supervision and
              guidance the experts at Mawalla Advocates, he has developed to
              become an expert with multiple and exceptional solutions on the
              problems and challenges arising on his field of practice.
              <div>
                <a href="/denice.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Managing Partner <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 657 572 175
                <br /> E: denice.tumaini@lexmicus.co.tz
              </div>
            </div>
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-left"
            >
              <img
                src="https://1.bp.blogspot.com/-83gN1D9V214/YP73YRbrK7I/AAAAAAAABWg/KnBKVdOPoiAsFZvkCsqZ686nYOQ1RJEhQCLcBGAsYHQ/s16000/DENIS.jpg"
                alt="pic"
                className=" w-full  object-cover"
              />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #f5f5f5)",
                }}
              />
            </div>
          </div>
        </div>

        {/* ----------------------ANDREW SECHA-------------------- */}
        <div
          className="p-10 "
          style={{
            background: "#d1d4da",
          }}
        >
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>ANDREW SECHA || Partner</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img
                src="https://1.bp.blogspot.com/-_orVDetxnwg/YP73ouv3bZI/AAAAAAAABWo/WO3-QwRpKIs-thm68ptK27OAEM082mb4wCLcBGAsYHQ/s16000/ANDREW.jpg"
                alt="pic"
                className=" object-cover"
              />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #d1d4da)",
                }}
              />
            </div>
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              Andrew Secha is an Advocate of the High Court of Tanzania and
              Courts Subordinate thereto save for the Primary Courts. He works
              as the head of the Corporate and recovery department at Lexmicus
              Attorneys and also act as Administrative Partner. Andrew Secha
              worked at Apex Attorneys (Advocates) and GEKC Attorneys, he has
              built a carrier and gained experience around Corporate at all its
              levels. His other specializations include banking law, oil & gas,
              mining sector taxation, company law, corporate finance and
              corporate taxation. He has expertise in arbitration and other
              means to the Alternative Dispute Resolution. He brings to the team
              not only corporate skills but also negotiation and arbitration
              skills which he has acquired over a time.
              <div>
                <a href="/andrew.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Partner <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 715 850 450 <br />
                E: andrew.secha@lexmicus.co.tz
              </div>
            </div>
          </div>
        </div>

        {/* ------------------------- SASSI M. SASSI ------------------------------ */}
        <div
          className="p-10   "
          style={{
            background: "#d1d4da",
          }}
        >
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>SASSI M. SASSI || Associate</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img src="sassy.jpeg" alt="pic" className=" object-cover" />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #d1d4da)",
                }}
              />
            </div>
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              Sassi is a dedicated Legal Associate with over one and a half
              years of experience working in a dynamic law firm environment. He
              has gained hands-on expertise in legal research, drafting
              pleadings, client advisory, and supporting litigation and
              corporate transactions. He is known for his meticulous attention
              to detail, strong analytical skills, and ability to work
              collaboratively with legal teams and clients.
              <div>
                <a href="/sassy.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Associate <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 752 325 011
                <br /> E: sassi.sassi@lexmicus.co.tz
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------BELINDA MJEMA------------------------ */}
        <div className="p-10 ">
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>BELINDA MJEMA || Principal Associate</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="md:w-2/3 w-full md:pr-4"
              align="justify"
              data-aos="fade-right"
            >
              Belinda is a corporate and commercial law expert attorney with
              experience in handling facility and syndicate agreements as well
              as security documents. A track record for collaborating with Women
              Lawyers Committee of East Africa Law Society, as a secretary for
              the budget committee for Tanzania. A competent public policy
              analyst with strong ties to government and its liaisons.
              <div>
                <a href="/belinda.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Principal Associate <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 758 811 269
                <br /> E: belindamjema@gmail.com
              </div>
            </div>
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-left"
            >
              <img
                src="belinda.png"
                alt="pic"
                className=" w-full  object-cover"
              />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #f5f5f5)",
                }}
              />
            </div>
          </div>
        </div>
        {/* -------------------------NIXON YONA --------------------------------- */}
        <div
          className="p-10   "
          style={{
            background: "#d1d4da",
          }}
        >
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>NIXON YOHANA || Legal Officer</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img src="nixon.jpeg" alt="pic" className=" object-cover" />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #d1d4da)",
                }}
              />
            </div>
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              Nixon is an energetic and dynamic graduate legal officer and
              aspiring advocate of the high court of Tanzania. He is an
              effective communicator and has an incredible ability for attention
              to detail whilst executing legal research for building cases and
              gathering necessary evidence. A great communicator capable of
              presenting large amounts of facts effectively.
              <div>
                <a href="/nixon.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Legal Officer <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 785 999 575
                <br /> E: intern@lexmicus.co.tz
              </div>
            </div>
          </div>
        </div>
        {/* ---------------------------FLORA---------------------------------- */}
        <div className="p-10 ">
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>FLORA SHAANAELI MURO || Administrative Assistant</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="md:w-2/3 w-full md:pr-4"
              align="justify"
              data-aos="fade-right"
            >
              Flora is a vibrant individual passionate about creating
              administrative efficiencies. She is very inquisitive with a joy in
              exploring new ways in doing things to meet business objectives. A
              compassionate and open-minded professional with the ability to
              adapt to different environments and contribute overall value. She
              is an excellent communicator in written and spoken language and a
              team player.
              <div>
                <a href="/flora.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Administrative Assistant <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 673 777 647
                <br /> E: info@lexmicus.co.tz
              </div>
            </div>
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-left"
            >
              <img
                src="flora.jpeg"
                alt="pic"
                className=" w-full  object-cover"
              />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #f5f5f5)",
                }}
              />
            </div>
          </div>
        </div>

        {/* -------------------------ALBERT SECHA--------------------------------- */}
        <div
          className="p-10   "
          style={{
            background: "#d1d4da",
          }}
        >
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>ALBERT SECHA || IT Specialist</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img
                src="https://1.bp.blogspot.com/-h3liwqwHhOE/YP_RImX1XtI/AAAAAAAABXU/-PcgGv89CEwNtexoOFv7HUCZLw_440o_ACLcBGAsYHQ/s16000/ALBERT.jpg"
                alt="pic"
                className=" object-cover"
              />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #d1d4da)",
                }}
              />
            </div>
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              Albert is a highly skilled and innovative Information Technology
              Specialist with more than eight years experience in leading IT
              administration and operations in various industries in the
              country. He has a proven track record of maintaining ICT network
              security and efficiency at various organizational levals. A team
              player dedicated to efficient problem solving.
              <div>
                <a href="/albert.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                IT Specialist <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 717 618 218
                <br /> E: sechaalbert@lexmicus.co.tz
              </div>
            </div>
          </div>
        </div>

        {/* -----------------------------NEEMA ALFRED ----------------------------------- */}
        <div className="p-10  ">
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>NEEMA ALFRED || Intern</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              <div>
                With a year of experience navigating the complexities of legal
                practice, Neema has developed a strong foundation in legal
                procedures, document drafting, and case management. As a Legal
                Officer and Legal Secretary, Neema has honed a meticulous
                attention to detail, ensuring the accurate preparation and
                handling of legal documents while facilitating seamless
                communication between clients, attorneys, and key stakeholders.
              </div>
              <div>
                <a href="/neema.pdf">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Intern <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 767 253 689 <br />
                E: neema.alred@lexmicus.co.tz
              </div>
            </div>
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img src="neema.png" alt="pic" className=" object-cover" />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #dbeafe)",
                }}
              />
            </div>
          </div>
        </div>

        {/* -------------------------BRENDA MAWASE--------------------------------- */}
        <div
          className="p-10   "
          style={{
            background: "#d1d4da",
          }}
        >
          <div
            style={{
              color: "#8C191B",
            }}
            className="my-4"
            data-aos="zoom-out"
          >
            <b>BRENDA MASSAWE || Intern</b>
          </div>
          <div className="flex flex-wrap md:flex-nowrap">
            <div
              className="relative md:w-1/3 w-full  px-2 md:pl-2 md:pr-0"
              data-aos="fade-right"
            >
              <img src="brenda.jpg" alt="pic" className=" object-cover" />
              <div
                className="absolute bottom-0 w-full md:pl-2 px-2"
                style={{
                  height: "40vh",
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0), #d1d4da)",
                }}
              />
            </div>
            <div
              className="md:w-2/3 w-full md:pl-4"
              align="justify"
              data-aos="fade-left"
            >
              A dedicated and detail-oriented Legal Officer Intern with over one
              year of experience serving as an Assistant Legal Officer in
              reputable law firms. She has gained hands-on experience in legal
              drafting, legal research, case preparation, court filing
              procedures, and attending court sessions. Her exposure to both
              litigation and advisory work has equipped her with a solid
              understanding of legal processes and courtroom practice.
              <div>
                <a href="/brenda.pdf" target="_blank">
                  <button className="px-2 py-1 bg-red-700 text-white flex my-4">
                    Read more
                  </button>
                </a>
                Intern <br />
                Plot No. 257, Regent Estate, <br />
                Vikawe St, Mikocheni, <br />
                P.O.BOX 7063, <br />
                Dar Es salaam.
                <br />
                <br />
                T: +255 767 253 689
                <br /> E: brenda.massawe@lexmicus.co.tz
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainTeam;
